import { render, staticRenderFns } from "./ExportBtns.vue?vue&type=template&id=3a04b7b6&scoped=true"
import script from "./ExportBtns.vue?vue&type=script&lang=js"
export * from "./ExportBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04b7b6",
  null
  
)

export default component.exports